import { useEffect } from 'react'
import { Container } from 'react-bootstrap'

import { ROUTE_TODAY } from '../common/helpers/Paths'
import Membership from '../account/Membership'
import ComplianceFooter from '../common/navigation/ComplianceFooter'

/**
 * Simple Plan Selection component. Used to display a plan selection lockup with a membership CTA with a simple URI trigger
 */
export default function PlanSelection({ user, setHeaderTitle, setReturnPath }) {
  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0)

    setHeaderTitle('Remble Membership')
    setReturnPath(ROUTE_TODAY)
  }, [setReturnPath, setHeaderTitle])

  return (
    <Container className='plan-selection-container'>
      <Membership user={user} />
      <ComplianceFooter />
    </Container>
  )
}
